<template>
    <b-row>
        <b-col cols="0" v-if="! plazos">
            <button
                :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'"
                :disabled="disabled"
                data-cy="pago-plazos"
                @click="show_modal = true"
            >
                <span>{{ $t('bases.pago_plazos') }}</span>
            </button>
        </b-col>
        <b-col cols="0" v-else>
            <button :class="!esMovil ? 'button effect-button large-button mr-2' : 'button effect-button mr-2'" @click="reset()" :disabled="disabled"><span>{{ $t('bases.importe_completo') }}</span></button>
            <button :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" @click="show_modal = true" :disabled="disabled"><span>{{ $t('bases.modificar_plazos') }}</span></button>
        </b-col>
        <b-col cols="12" v-if="error_plazos">
            <b-alert
                class="mt-3"
                :show="error_plazos"
                variant="danger"
            >
                No es posible fraccionar los plazos de pago con fecha superior a fecha {{ teatro.fecha_limite_plazos }}
            </b-alert>
        </b-col>

        <b-modal
            size="lg"
            centered
            :hide-footer="true"
            v-model="show_modal"
            :title="$t('bases.activar_plazos')"
        >
            <b-row>
                <b-col cols="12">
                    <p>{{ $t('bases.texto_plazos') }}</p>
                </b-col>
                <b-col cols="12">
                    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                        <b-row>
                            <b-col md="6" sm="12">
                                <ValidationProvider name="cuotas" id='cuotas' rules="required" class="mr-2" v-slot="{ errors }">
                                    <multiselect
                                        v-model="data.plazoSelect"
                                        data-cy="cuotas"
                                        id='cuotas-input'
                                        :placeholder="$t('bases.cantidad_disponible')"
                                        :options="cuotas"
                                        :show-labels="false"
                                        :max-height="150"
                                    />
                                    <span v-if="errors[0]" class="error invalid-feedback alert-danger white p-1" style="display: block">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6" sm="12">
                                <ValidationProvider v-if="frecuencias.length > 0" name="frecuencia" id='frecuencia' rules="required" v-slot="{ errors }">
                                    <multiselect
                                        v-model="data.frecuenciaSelect"
                                        data-cy="frecuencias"
                                        id='frecuencias-input'
                                        label="frecuencia_formatted"
                                        track-by="id"
                                        :placeholder="$t('bases.frecuencia_disponible')"
                                        :options="frecuencias"
                                        :show-labels="false"
                                        :max-height="150"
                                    />
                                    <span v-if="errors[0]" class="error invalid-feedback alert-danger white p-1" style="display: block">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b v-if="tiene_gastos"><p>{{ $t('bases.aviso_gd', {gd: gastos}) }}</p></b>
                        <div class="mt-3">
                            <Button class="mr-2" type="button" name="button" @click="terminar()" data-cy="confirmar-plazos" :disabled="disabled">{{ $t('formularios.continuar') }}</Button>
                            <Button type="button" name="button" @click="show_modal = false" :disabled="disabled">{{ $t('formularios.atras') }}</Button>
                        </div>
                    </ValidationObserver>
                </b-col>
            </b-row>
        </b-modal>
    </b-row>
</template>

<script>

    export default {
        props: {
            frecuencias: {
                type: Array,
                required: true
            },
            min_plazos: {
                type: Number,
                required: true
            },
            max_plazos: {
                type: Number,
                required: true
            },
            gastos: {
                type: Number,
                required: true
            },
            error_plazos: {
                type: Boolean,
                required: false,
                default:false
            },
            tiene_gastos: {
                type: Boolean,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            },
            esMovil: {
                type: Boolean
            }
        },
        data() {
            return {
                data: {},
                show_modal: false,
                plazos: false
            }
        },
        watch: {
            show_modal() {
                this.data = {};
            }
        },
        computed: {
            cuotas() {
                let cuotas = [];

                for (var i = this.min_plazos; i <= this.max_plazos; i++) {
                    cuotas.push(i);
                }

                return cuotas;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        methods: {
            async terminar() {
                const isValid = await this.$refs.observer.validate();

                if (isValid) {
                    this.plazos = true;
                    this.show_modal = false;
                    this.$emit("terminado", this.data);
                }
            },
            reset() {
                this.plazos = false;
                this.$emit('reset');
            }
        }
    }
</script>
